export default (bonus: number = 50) => ({
    add: 'Ajouter un cheval',
    allOrders: 'Tous les ordres',
    orderAvailable:
        'Utilisez le glisser-déposer sur les numéros pour sélectionner votre ordre',
    associate: 'Associé',
    base: 'Base',
    bet: 'Pari',
    betTypeDisabled: 'Pari bientôt disponible',
    betAmount: 'Montant du pari',
    chooseHorses: 'Choisir mes chevaux',
    combined: 'Combiné',
    finish: 'Terminer',
    identicalBets: 'Vos mises doivent être identiques',
    imminent: 'Imminent',
    invalidBet: 'Pari invalide',
    mySelection: 'Ma sélection',
    noHorseSelected: 'Aucun cheval sélectionné',
    notRegisteredYet: 'Pas encore inscrit ?',
    odd: 'Rap. prob.',
    partWheel: 'Champ réduit',
    placeBet: 'Placé',
    prepareBet: 'Préparer mon pari',
    selectedBet: 'Mise sélectionnée',
    signUp: 'Créer mon compte (250€ offerts)',
    stake: 'Mise',
    totalBet: 'Enjeu total',
    totalWheel: 'Champ total',
    unavailable: 'Indisponible',
    unit: 'Unitaire',
    validateOn: 'Valider sur',
    winBet: 'Gagnant',
    smsBetConditions:
        'Pour parier par SMS sur plusieurs partants en Simple, toutes vos mises doivent êtres identiques et tous vos paris doivent être gagnants, placés ou les deux.',
    warning: 'Attention',
    pmuAccountRequired:
        "Pour utiliser cette fonctionnalité, vous avez besoin d'un compte PMU+",
    pmuShortAccountRequired:
        "Vous avez besoin d'un compte PMU+ pour valider vos paris",
    pmuAccountCreated: "J'ai déjà un compte",
    createAccountAndGetBonus: `Créer un compte PMU+ (jusqu'à ${bonus}€ de bonus)`,
    createShortAccountAndGetBonus: `Créer un compte PMU+ (jusqu'à ${bonus}€ de bonus)`,
    dontAskAgain: 'Ne plus me demander',
    close: 'Fermer',
    playBySms: 'Jouer par SMS',
    missingBase: 'Veuillez sélectionner au moins une base'
})
